"use client";

import { Box, Link, Stack, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import NextLink from "next/link";

const NotFound = () => {
  return (
    <Box
      component="main"
      sx={{
        minHeight: "100dvh",
        display: "grid",
        placeItems: "center",
        px: 2,
        py: 6,
        bgcolor: "background.default",
      }}
    >
      <Stack
        spacing={2}
        sx={{
          width: "100%",
          maxWidth: 560,
          alignItems: { xs: "center", sm: "flex-start" },
          textAlign: { xs: "center", sm: "left" },
        }}
      >
        <Typography
          component="p"
          sx={{
            color: "text.primary",
            fontSize: { xs: "6rem", sm: "8rem" },
            fontWeight: 800,
            letterSpacing: "-0.08em",
            lineHeight: 0.95,
          }}
        >
          404
        </Typography>
        <Typography component="h1" variant="h2">
          Page not found
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ maxWidth: 520, mb: 1 }}
        >
          The page you’re looking for may have been moved, renamed, or is
          temporarily unavailable.
        </Typography>
        <Link
          component={NextLink}
          href="/"
          underline="none"
          sx={{
            mt: 1,
            display: "inline-flex",
            alignItems: "center",
            gap: 0.75,
            color: "text.primary",
            fontWeight: 600,
            "&:hover": {
              color: "text.secondary",
              textDecoration: "underline",
            },
          }}
        >
          Go back to dashboard
          <ArrowForwardIcon sx={{ fontSize: "1rem" }} />
        </Link>
      </Stack>
    </Box>
  );
};

export default NotFound;
